import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function () {
    return createStyles({
        google: {
            width: '100%',
            height: '50px',
            border: '1px solid var(--gris-l43)',
            borderRadius: '50px',
            backgroundColor: 'white',
            opacity: '0.9',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '3.375rem',
            paddingRight: '4.125rem',
            justifyContent: 'space-between',
            marginBottom: '2.125rem',
            cursor: 'pointer',
        },
        icono__google: {},
        google_descripcion: {
            color: 'var(--gris-l43)',
            fontWeight: 600,
        },
    });
});
export default useStyles;
